export default __webpack_public_path__ + "static/vechain-50219b69fffaa4c3fcd00c74dfff9303.png";